import { Button, IconButton } from "@mui/material";
import { useState } from "react";
import { Remarkable } from 'remarkable';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
interface Props {
    context:string;
}

export default function TextSizeContext({context}:Props){

  
    const [fontSize, setFontSize] = useState<number>(20); // Default font size is 16px

    // Function to increase font size
    const increaseFontSize = () => setFontSize(fontSize + 1);
  
    // Function to decrease font size
    const decreaseFontSize = () => setFontSize(fontSize - 1);
    const md = new Remarkable();

    // Convert Markdown text to HTML
    const renderText = (text: string) => {
    const modifiedText = text.replace(/^(bot|user|assistant):\s*/i, '');

      const rawMarkup = md.render(modifiedText);
      return { __html: rawMarkup };
    };

    return (
        <>
        <IconButton  onClick={increaseFontSize}><ZoomInIcon  /></IconButton>
        <IconButton aria-label="delete" onClick={decreaseFontSize}><ZoomOutIcon /></IconButton>

        <p style={{ fontSize: `${fontSize}px` }} dangerouslySetInnerHTML={renderText(context)}></p>

        </>
    )
}